<template>
  <div id="rightBottom">
    <div class="bg-color-black">
      <div class="d-flex pt-2 pl-2">
        <div class="d-flex">
          <span class="fs-xl text mx-2">报警动态监测</span>
          <dv-decoration-3 class="dv-dec-3" />
        </div>
      </div>
      <div class="d-flex ai-center flex-column body-box">
        <dv-scroll-board
          :config="config"
          style="width:500px;height:220px;margin-top:20px"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      config: {
        header: [
          '<span style="color:#e7bcf3;">告警用户</span>',
          '<span style="color:#e7bcf3; padding-left:40px;">告警内容</span>',
          '<span style="color:#e7bcf3; padding-left:40px;">告警状态</span>',
          '<span style="color:#e7bcf3; padding-left:20px;">创建时间</span>'
        ],
        rowNum: 7, //表格行数
        headerHeight: 35,
        headerBGC: "#124a7b", //表头
        oddRowBGC: "#0f1325", //奇数行
        evenRowBGC: "#171c33", //偶数行
        columnWidth: [80],
        align: ["center"]
      }
    };
  },
  created() {
    var datas = [
      {
        userName: "test0303",
        content: "5分钟内出现3次非法操作",
        status: "未警告",
        gmtCreate: "2022-03-07 10:36:00"
      },
      {
        userName: "test0303",
        content: "5分钟内出现3次非法操作",
        status: "未警告",
        gmtCreate: "2022-03-07 10:36:00"
      },
      {
        userName: "test0303",
        content: "5分钟内出现3次非法操作",
        status: "未警告",
        gmtCreate: "2022-03-07 10:36:00"
      },
      {
        userName: "test0303",
        content: "5分钟内出现3次非法操作",
        status: "未警告",
        gmtCreate: "2022-03-07 10:36:00"
      },
      {
        userName: "test0303",
        content: "5分钟内出现3次非法操作",
        status: "未警告",
        gmtCreate: "2022-03-07 10:36:00"
      },
      {
        userName: "test0303",
        content: "5分钟内出现3次非法操作",
        status: "未警告",
        gmtCreate: "2022-03-07 10:36:00"
      },
      {
        userName: "test0303",
        content: "5分钟内出现3次非法操作",
        status: "未警告",
        gmtCreate: "2022-03-07 10:36:00"
      },
      {
        userName: "test0303",
        content: "5分钟内出现3次非法操作",
        status: "未警告",
        gmtCreate: "2022-03-07 10:36:00"
      },
      {
        userName: "test0303",
        content: "5分钟内出现3次非法操作",
        status: "未警告",
        gmtCreate: "2022-03-07 10:36:00"
      },
      {
        userName: "test0303",
        content: "5分钟内出现3次非法操作",
        status: "未警告",
        gmtCreate: "2022-03-07 10:36:00"
      },
      {
        userName: "test0303",
        content: "5分钟内出现3次非法操作",
        status: "未警告",
        gmtCreate: "2022-03-07 10:36:00"
      },
      {
        userName: "test0303",
        content: "5分钟内出现3次非法操作",
        status: "未警告",
        gmtCreate: "2022-03-07 10:36:00"
      },
      {
        userName: "test0303",
        content: "5分钟内出现3次非法操作",
        status: "未警告",
        gmtCreate: "2022-03-07 10:36:00"
      }
    ];
    this.config["data"] = datas.map(item => {
      item.content = `<span class='colorBlue'>${item.content}</span>`;
      item.status = `<span  class='colorGrass'>${item.status}</span>`;
      return item;
    });
  }
};
</script>

<style lang="scss" scoped>
$box-height: 320px;
$box-width: 550px;
#rightBottom {
  padding: 16px;
  height: $box-height;
  width: $box-width;
  border-radius: 10px;
  .bg-color-black {
    height: $box-height - 30px;
    border-radius: 10px;
  }
  .text {
    color: #c3cbde;
  }
  .dv-dec-3 {
    position: relative;
    width: 100px;
    height: 20px;
    top: -3px;
  }

  .bottom-data {
    .item-box {
      & > div {
        padding-right: 5px;
      }
      font-size: 14px;
      float: right;
      position: relative;
      width: 50%;
      color: #d3d6dd;
      .dv-digital-flop {
        width: 120px;
        height: 30px;
      }
      // 金币
      .coin {
        position: relative;
        top: 6px;
        font-size: 20px;
        color: #ffc107;
      }
      .colorYellow {
        color: yellowgreen;
      }
      p {
        text-align: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/screen/RightBottom.vue